import AdminLayout from '../../components/dashboard/admin/AdminLayout';
import AdminDashboard from '../../components/dashboard/admin/AdminDashboard';

const Dashboard = () => {
  return (
    <AdminLayout>
      <AdminDashboard />
    </AdminLayout>
  );
};

export default Dashboard;